<template lang="pug">
.main
  v-layout(style="height:100vh")
    v-container.my-auto(style="max-width: 600px;" outlined)
      h5.text-center.my-6.grey--text.text--darken-3 Tell us about yourself
      v-card.mt-4.pb-8(flat :tile="this.$vuetify.breakpoint.xs" :class="{'px-8': !this.$vuetify.breakpoint.xs}")
        v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
          v-form(ref="form" v-model="valid")
            p.mb-1.label.basic600--text.text-uppercase First Name
            v-text-field.mt-2(color="primary" v-model="form.first_name" type="text"  :rules="rules.first_name" dense solo flat background-color="basic200" outlined height="40")
              template(v-slot:label)
                .p1.basic600--text Enter your first name
            p.mb-1.label.basic600--text.text-uppercase Last Name
            v-text-field.mt-2(color="primary" v-model="form.last_name" type="text" :rules="rules.last_name" dense solo flat background-color="basic200" outlined   height="40")
              template(v-slot:label)
                .p1.basic600--text Enter your last name
            template(v-if="invitation.email")
              p.mb-1.label.basic600--text.text-uppercase Phone Number
              y-phone-input.my-4(v-model="phone")
              p.mb-1.label.basic600--text.text-uppercase Password
              v-text-field.mt-2(color="primary" v-model="form.password" type="password" :rules="rules.password" outlined dense solo flat background-color="basic200"    height="40")
                template(v-slot:label)
                  .p1.basic600--text Create a password
            y-checkbox.mt-0(v-model="agreedTerm" :rules="rules.agreedTerm")
              template(v-slot:label)
                span
                  | I agree to Yezza&nbsp;
                  a(href="https://yezza.io/term-of-use/") Terms
                  | &nbsp;and&nbsp;
                  a(href="https://yezza.io/privacy-policy/") Privacy Policy
            y-checkbox.mt-0(v-model="waOptin")
              template(v-slot:label)
                span I agree to receive notification and promotion messages via WhatsApp
            v-btn.mt-8.button-AA-medium.white--text(color="info500" x-large block depressed @click="submit" :loading="loading" height="40") Continue
</template>

<script>
import TopBar from '@/components/TopBar'
import { mapActions } from 'vuex'

export default {
  name: 'InviteSignUp',
  components: { TopBar },
  props: ['invitation', 'token'],
  data: () => ({
    loading: false,
    agreedTerm: false,
    waOptin: false,
    valid: false,
    phone: '',
    form: {
      first_name: '',
      last_name: '',
      password: null,
    },
    rules: {
      first_name: [
        v => !!v || 'First name is required'
      ],
      last_name: [
        v => !!v || 'Last name is required'
      ],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
      password: [
        v => !!v || 'Password is required'
      ],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ]
    }
  }),
  computed: {
    phoneSanitized () {
      let phone = ''
      if (this.invitation.email) {
        phone = this.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      } else if (this.invitation.phone) {
        phone = this.$options.filters.removePhoneAlias(this.invitation.phone)
      }
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    submit () {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.loading = true
      let form = {...this.form, invite_token: this.token }
      this.$axios.post('/users/', form)
        .then(resp => {
          this.$store.commit('user/setUser', resp.data)
          if (this.waOptin) {
            this.$axios.patch(`/users/${resp.data.id}/`, { whatsapp_optin: true })
              .then(resp => {
                this.$store.commit('user/setUser', resp.data)
              })
              .catch(() => {})
          }
          let data = {
            method: 'invite_token',
            company: this.invitation.company.id,
            role: this.invitation.role,
            phone: this.phoneSanitized,
            invite_token: this.token,
            user_email: this.invitation.email,
            app: this.invitation.app
          }
          this.$axios.post('/members/', data)
            .then(resp => {
              if (data.app === 'connect') {
                this.handleConnectUser(resp.data)
              } else {
                this.$store.commit('user/setMember', resp.data)
                this.$router.push('/admin/dashboard')
              }
            })
            .catch(() => {})
        })
        .catch(e => {
          if (e.response) {
            if (e.response.data.email) {
              this.showMessage(['error', e.response.data.email[0]])
            }
            if (e.response.data.password) {
              this.showMessage(['error', e.response.data.password[0]])
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleConnectUser (user) {
      this.$router.push({ name: 'InviteConnectComplete', params: { user }})
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>